import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useOpenWebhookModalEdit } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createIntegration')
  const openModal = useOpenWebhookModalEdit()

  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openModal} />
}

export default AddNewButton
